export default __webpack_public_path__ + "static/SYNCHRO LAMINATES-34018f3deee24c3f882d136c175fe621.webp";